import { TickIcon } from '@mr-yum/frontend-ui'
import { config } from 'lib/config'
import { routes } from 'lib/routes'
import React from 'react'

interface Props {
  venueSlug: string
  tabId?: string
  orderId?: string
}

export const ConfirmationBannerIcon = ({ venueSlug, tabId }: Props) => {
  const path = tabId
    ? routes.socialTabJoin.toPath!({ venueSlug, tabId: tabId || '' })
    : null

  return (
    <div className="relative">
      {path ? (
        <div className="relative -top-8 -mb-8 flex justify-center rounded-sm">
          <img
            src={`${config.manageApiUrl}/qr-redirect/generate${path}.svg`}
            className="h-[124px] w-[124px]"
          />
        </div>
      ) : (
        <div className="relative -top-[29px] -mb-[29px] flex justify-center">
          <div className="flex h-[58px] w-[58px] items-center justify-center overflow-hidden rounded-full border-4 border-[theme(backgroundColor.surface-ui-background)] bg-surface-inverted text-[theme(backgroundColor.surface-ui-background)]">
            <TickIcon width={32} height={32} />
          </div>
        </div>
      )}
    </div>
  )
}
